import React, { useState, useEffect } from 'react';
import I18NextContext from './I18NextContext.jsx';
// import { getLanguageDetectionOptions, getLocaleResources, getFallbackLng } from '../../../utils/StoreConfigManager.js';
import i18n from '../../../../i18n/index.js';
import { useRef } from 'react';

// Right to left
const isRTL = () => i18n.dir(i18n.language) === 'rtl';

function I18NextContextComponent(props) {
    const { history } = props;
    const currentPathLocale = useRef(history.location.pathname.split('/')[1]);
    const availableLanguages = i18n.options.detection.availableLanguages;

    // Sets current language to locale set in url, defaults to i18n set language otherwise
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
    const [isRenderedRTL, setIsRenderedRTL] = useState(isRTL()); // RTL = Right to Left
    const [translations, setTranslations] = useState({});

    // Changes language based on locale set in path
    // useEffect(() => {
    //     if (currentPathLocale.current) {
    //         debugger
    //         let lang = availableLanguages.includes(currentPathLocale.current) ? currentPathLocale.current : availableLanguages[0];
    //         i18n.changeLanguage(lang);
    //         setCurrentLanguage(lang);
    //     }
    // }, [currentPathLocale.current]);

    // This use effect will trigger a change in state of isRendered RTL whenever a change in current language is detected
    useEffect(() => {
        setIsRenderedRTL(isRTL());
    }, [currentLanguage]);

    const getChangedUrl = (lang) => {
        const hashPath = window.location.hash;
        let parts = hashPath.split('/')
        parts[i18n.options.detection.lookupFromHashPathIndex] = lang;
        return window.location.origin + window.location.pathname + parts.join("/");
    }

    const changeLanguages = (lang) => {
        // event.preventDefault();
        if (lang === currentLanguage) { return };
        i18n.changeLanguage(lang).then(promise => {
            setCurrentLanguage(lang);
            window.open(getChangedUrl(lang), '_self');
        });

        // fetchTranslations(event.target.dataset.key);
    }

    const contextValue = {
        currentLanguage,
        isRenderedRTL,
        changeLanguages,
        translations,
        availableLanguages
    }
    return <I18NextContext.Provider value={contextValue}>{props.children}</I18NextContext.Provider>
}

export default I18NextContextComponent;
